import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary';

import { IntegrationPageContent } from './IntegrationPageContent';

// GPS data configuration page
export const IntegrationPage = withDefaultErrorBoundary(IntegrationPageContent)
